<template>
  <svg class="svg-inline--fa" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <title>loki</title>
    <path d="M6.884 31.386l-0.379-2.548-2.548 0.38 0.434 2.548 2.494-0.38z" fill="currentColor"></path>
    <path d="M26.833 24.23l-0.434-2.494-11.112 1.735 0.325 2.494 11.221-1.735z" fill="currentColor"></path>
    <path d="M11.654 26.616l2.548-0.434-0.379-2.494-2.548 0.379 0.379 2.548z" fill="currentColor"></path>
    <path d="M10.896 30.735l-0.434-2.494-2.494 0.379 0.325 2.548 2.602-0.434z" fill="currentColor"></path>
    <path d="M3.361 25.26l0.379 2.548 2.548-0.38-0.379-2.548-2.548 0.379z" fill="currentColor"></path>
    <path d="M15.828 27.374l0.434 2.602 11.167-1.735-0.379-2.548-11.221 1.68z" fill="currentColor"></path>
    <path d="M12.305 30.518l2.493-0.325-0.379-2.602-2.548 0.434 0.434 2.494z" fill="currentColor"></path>
    <path d="M7.318 24.664l0.434 2.548 2.494-0.379-0.38-2.548-2.548 0.38z" fill="currentColor"></path>
    <path d="M4.228 23.688l-3.090-20.273-1.138 0.163 3.144 20.273 1.084-0.163z" fill="currentColor"></path>
    <path d="M5.692 23.471l-3.361-21.791-1.084 0.217 3.361 21.737 1.084-0.163z" fill="currentColor"></path>
    <path d="M8.185 23.092l-3.523-23.092-1.084 0.217 3.523 22.984 1.084-0.108z" fill="currentColor"></path>
    <path d="M9.649 22.875l-3.252-21.032-1.030 0.163 3.252 20.978 1.030-0.108z" fill="currentColor"></path>
    <path d="M12.142 22.442l-2.873-18.647-1.084 0.163 2.873 18.701 1.084-0.217z" fill="currentColor"></path>
    <path d="M13.606 22.225l-2.981-19.352-1.084 0.163 3.036 19.352 1.030-0.163z" fill="currentColor"></path>
  </svg>
</template>
<script setup lang="ts"></script>
